import * as React from 'react';
import ProjectHeader from '../../../components/ProjectHeader/ProjectHeader';

export default function AccountSettingHeader() {
  return <ProjectHeader />;
}
